import { BiHomeAlt } from "react-icons/bi";

import { FaUserCircle, FaUserShield, FaBoxes } from "react-icons/fa";
import { PrivatePaths } from "../../routes/path";
import { GiNewspaper } from "react-icons/gi";
export const adminLinks = [
  {
    route: PrivatePaths.DASHBOARD,
    name: "Dashboard",
    Icon: BiHomeAlt,
    allowed: ["SuperAdmin", "User", "Admin"],
  },
  {
    route: PrivatePaths.CATEGORY,
    name: "Category",
    Icon: FaBoxes,
    allowed: ["SuperAdmin", "Admin", "User"],
  },
  {
    route: PrivatePaths.POSTS,
    name: "Posts",
    Icon: GiNewspaper,
    allowed: ["SuperAdmin", "Admin", "User"],
  },
  {
    route: PrivatePaths.ADMIN,
    name: "Admin",
    Icon: FaUserCircle,
    allowed: ["SuperAdmin", "Admin", "User"],
  },
  // {
  //   route: PrivatePaths.USERS,
  //   name: "Users",
  //   Icon: FaUserShield,
  //   allowed: ["SuperAdmin", "Admin", "User"],
  // },
];
